/* eslint-disable react/prop-types */
import React from 'react';
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

/**
 * Single-series total heart-rate-sessions-per-day trend (030 US3), on the shared
 * au-panel design system (matches MonitorSessionTrendChart / PauseTrendChart). Coral
 * line, text-labelled legend, point tooltip, graceful single-day/empty handling.
 * Single total line (clarification 2026-07-10) — tag mix lives in the Top-5 panel.
 *
 * Props: { data } — [{ date:'YYYY-MM-DD', sessions:int }] ascending
 */
const shortDate = (d) => (d ? String(d).split('-').slice(1).reverse().join('/') : '');

const HeartRateSessionTrendChart = ({ data = [] }) => {
  const enough = Array.isArray(data) && data.length >= 2;

  return (
    <div className="au-panel" data-testid="hr-trend">
      <div className="au-panel__head">
        <h4 className="au-panel__title">Heart rate sessions per day</h4>
        <span className="au-spacer" />
        <div className="au-legend">
          <span><i style={{ background: '#f26b45' }} />Heart rate sessions</span>
        </div>
      </div>

      {enough ? (
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 4 }}>
            <CartesianGrid stroke="#eef2f1" vertical={false} />
            <XAxis dataKey="date" tickFormatter={shortDate} tick={{ fontSize: 11, fill: '#94a3b8' }} />
            <YAxis width={44} tick={{ fontSize: 11, fill: '#94a3b8' }} allowDecimals={false} />
            <Tooltip
              formatter={(value) => [Number(value).toLocaleString(), 'Heart rate sessions']}
              labelFormatter={(l) => `Date: ${String(l).split('-').reverse().join('/')}`}
            />
            <Line type="monotone" dataKey="sessions" name="Heart rate sessions" stroke="#f26b45" strokeWidth={2.5} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className="au-chart-empty" data-testid="hr-trend-empty">
          Not enough data to plot a trend (need at least 2 days).
        </div>
      )}
    </div>
  );
};

export default HeartRateSessionTrendChart;
